{
  "process-container": {
    "text": {
      "back-to-home": "Zpět na domovskou stránku",
      "page-loading": "Stránka se načítá"
    }
  }
}
